import React, { useState, forwardRef } from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Popper from '@material-ui/core/Popper';

import {
    Text,
    StyledCard,
    StyledCardContent,
    CalendarIcon,
    GroupIcon,
    HorizontalRule,
    Avatar,
} from '../../index';

import { StyledTypeIndicator } from './style';

import { SESSION_COLORS } from '../../../constant';

const SessionPreviewCard = forwardRef(({ data, anchorEl, onClick }, ref) => {
    const [today] = useState(dayjs());
    const open = Boolean(anchorEl);

    return (
        <Popper
            ref={ref}
            open={open}
            anchorEl={anchorEl}
            placement="bottom-start"
            style={{
                margin: '10px 0',
                zIndex: 1200,
            }}
        >
            <StyledCard $backgroundColor="white" padding="24px 15px" $width="378px">
                <StyledCardContent
                    style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}
                >
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'auto 1fr',
                            columnGap: '10px',
                        }}
                    >
                        <StyledTypeIndicator $backgroundColor={SESSION_COLORS[data?.type]} />
                        <div>
                            <Text $medium $ellipsis>{`Activity name - ${data?.name}`}</Text>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    columnGap: '25px',
                                    marginTop: '10px',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        columnGap: '10px',
                                    }}
                                >
                                    <CalendarIcon fill="gray2" />
                                    <Text $color="gray2" $fontSize="12px">
                                        {`${
                                            today.isSame(dayjs(data?.startDate))
                                                ? 'Today'
                                                : dayjs(data?.startDate).format('DD MMM')
                                        }, ${data?.startTime?.slice(0, 5)} - ${data?.endTime?.slice(
                                            0,
                                            5
                                        )}`}
                                    </Text>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        columnGap: '10px',
                                    }}
                                >
                                    <GroupIcon fill="gray2" width="16px" height="16px" />
                                    <Text $color="gray2" $fontSize="12px">
                                        {`${data?.patients?.length} Participants`}
                                    </Text>
                                </div>
                            </div>
                        </div>
                    </div>
                    <HorizontalRule />
                    <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
                        <ParticipantsRow data={data?.staff?.user} isStaff />
                        {!_.isEmpty(data.patients) &&
                            data.patients.map((patient) => (
                                <ParticipantsRow key={patient.id} data={patient.user} />
                            ))}
                    </div>
                    <HorizontalRule />
                    <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
                        <Text $fontSize="12px" $medium>
                            Description
                        </Text>
                        <Text $fontSize="12px" $color="gray2" $ellipsis $lineClamp={4}>
                            {data.description}
                        </Text>
                    </div>
                    <div>
                        <Text
                            $fontSize="14px"
                            $color="blue3"
                            $medium
                            style={{ textAlign: 'right' }}
                            onClick={onClick}
                        >{`View more >`}</Text>
                    </div>
                </StyledCardContent>
            </StyledCard>
        </Popper>
    );
});

SessionPreviewCard.propTypes = {
    data: PropTypes.object.isRequired,
    anchorEl: PropTypes.object,
    onClick: PropTypes.func,
};
export default SessionPreviewCard;

const ParticipantsRow = ({ data, isStaff }) => {
    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: 'auto 1fr auto',
                alignItems: 'center',
                width: '100%',
                columnGap: '10px',
                paddingLeft: '10px',
                paddingRight: '5px',
            }}
        >
            <Avatar
                src={!data ? null : data?.avatar?.url}
                alt={!data ? '' : data?.fullname}
                $avatarSize="24px"
                $borderRadius="50%"
            />
            <Text $fontSize="12px" $color="gray1">
                {!data ? 'Inactive' : data?.fullname}
            </Text>
            {isStaff && (
                <Text $fontSize="12px" $color="green">
                    Host
                </Text>
            )}
        </div>
    );
};

ParticipantsRow.propTypes = {
    data: PropTypes.object,
    isStaff: PropTypes.bool,
};
